import { useEffect } from "react";

import { useAppSelector } from "../useAppSelector";
import { useAppDispatch } from "../useAppDispatch";

import { clearAutocompleteList } from "../../store/slice/health-monitor/device-list";

export const useClearAutocompleteSearch = () => {
  const searchInput = useAppSelector((state) => state.deviceList.searchInput);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (searchInput !== null && searchInput.length === 0) {
      dispatch(clearAutocompleteList());
    }
  }, [searchInput, dispatch]);
};
